
import React, {useEffect, useState} from 'react';
import {booking_count_total} from '../../../service/booking'
import rombus from '../../../media/rombus.gif'

const BookingCountBlock = ({prod_type=null, date_from=null, date_to=null, journey_step=0, title=null, sub_title=null, token, timeout=1000}) => {

    const [booking_d, set_data] = useState(null);

    const  popd = (date_from, date_to, prod_type) => {
        const limit = 8;
        setTimeout(() => {
            booking_count_total(date_from, date_to, prod_type, token).then((d) => {
            if(d != null){
                set_data(d)
            }
        }); 
        }, timeout);

    }
    

    let cTitle = 'Bookings';
    if(title != null){
        cTitle = title;
    }

    let cSubTitle = '';
    if(sub_title != null){
        cSubTitle = sub_title;
    }


    useEffect(() =>{
        popd(date_from, date_to, prod_type);
    }, [, date_from, date_to, prod_type])


    if(booking_d == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }

    const formatted = Number(booking_d).toLocaleString('en-US');

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='info'>{formatted}</div>
            <div className='info infosmall'>{cSubTitle}</div>
        </div>
    </div>)

}

export default BookingCountBlock
